// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divider[data-v-7a826560]{display:flex;justify-content:center;align-items:center;gap:1rem;color:#4e4e4e;margin:1.5rem 0}.divider .line[data-v-7a826560]{width:100%;height:2px;background:#4e4e4e}a[data-v-7a826560]{background:#333;color:#fff!important;transition:background-color .2s}a[data-v-7a826560]:hover{background:rgba(51,51,51,.9)}", ""]);
// Exports
module.exports = exports;
